export default {
      id: "ic-soc-instagram-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic-soc-instagram-usage",
      toString: function () {
        return this.url;
      }
    }